import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client/core'
import { MUTATION_REFRESH_SESSION } from '@/graphql'

export const state = {
  isRefreshing: false,
  pendingRequests: [],
}

export const addPendingRequest = (callback) => {
  state.pendingRequests.push(callback)
}

export const resolvePendingRequests = () => {
  state.pendingRequests.forEach((cb) => cb())
  state.pendingRequests = []
}

const refreshClient = new ApolloClient({
  link: new HttpLink({
    uri: process.env.VUE_APP_GRAPHQL_HTTP,
    credentials: 'include',
  }),
  cache: new InMemoryCache(), // no need to persist results
})

export const isExpiredError = (e) => {
  return [
    'session.expired',
    'authentication.missing.session.id',
    'authentication.error.expired.jwt.token',
    'Context creation failed: authentication.error.expired.jwt.token',
  ].includes(e.message)
}

export const isRefreshExpiredError = (e) => {
  return ['session.refresh.expired'].includes(e.message)
}

export function refreshSession() {
  return refreshClient
    .mutate({
      mutation: MUTATION_REFRESH_SESSION,
    })
    .then((res) => res.data)
}
